/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KoddiAPI from 'api';
import { takeLatest, call, all, put } from 'redux-saga/effects';
import SagaRegistry from 'redux-core/sagaRegistry';
import { fetchKPICardDataSuccess, fetchKPICardDataError } from './actions';

import { KPICardDataAction, FetchKPICardDataAction } from './types';

export function* fetchKPICardDataSaga(
    action: FetchKPICardDataAction
): Generator<any, void, any> {
    try {
        /* @ts-ignore */
        const response = yield call(
            KoddiAPI.Report.fetchTotalReport,
            action.payload.reportPayload
        );
        yield put(fetchKPICardDataSuccess(response));
    } catch (e) {
        const error = e as { error?: { message?: string } };
        yield put(
            fetchKPICardDataError(error.error?.message || 'Unknown error')
        );
    }
}

export function* watchDashboard() {
    yield takeLatest(
        KPICardDataAction.FETCH_KPI_CARD_DATA,
        fetchKPICardDataSaga
    );
}

function* dashboardSagas() {
    yield all([watchDashboard()]);
}

SagaRegistry.registerSaga(dashboardSagas);
